import axios from "axios";
import {
  API_URL,
  GYPSYBALL_PYTHON_API_URL,
  LOGINAPP_API_URL,
  GYPSYBALL_PYTHON_API_TOKEN,
} from "configs";
import { constructFrom } from "date-fns";
import { isEmpty } from "lodash";
import { use } from "react";
import { useDispatch } from "react-redux";
import { trimAndLimit } from "utils/general";
import { v4 as uuidv4 } from "uuid";
export const WORKSPACE_REQUEST = "WORKSPACE_REQUEST";
export const WORKSPACE_SUCCESS = "WORKSPACE_SUCCESS";
export const USER_ACCESS = "USER_ACCESS";
export const WORKSPACE_VALIDATION_ERROR = "WORKSPACE_VALIDATION_ERROR";
const SHOW_SNACKBAR = "SHOW_SNACKBAR";
export const HIDE_WORKSPACE_FEILD_VALIDATION_ERROR =
  "HIDE_WORKSPACE_FEILD_VALIDATION_ERROR";
export const REDIRECT_TO_WORKSPACE_LIST = "REDIRECT_TO_WORKSPACE_LIST";
export const REDIRECT_TO_WORKSPACE_CONFIGURATION_LIST =
  "REDIRECT_TO_WORKSPACE_CONFIGURATION_LIST";
export const WORKSPACE_GET_SUCCESS = "WORKSPACE_GET_SUCCESS";
export const WORKSPACE_DROPDOWN_LIST_SUCCESS =
  "WORKSPACE_DROPDOWN_LIST_SUCCESS";
export const WORKSPACE_SERVER_SUCCESS = "WORKSPACE_SERVER_SUCCESS";
export const CHAT_GET_LLM_MODEL_SUCCESS = "CHAT_GET_LLM_MODEL_SUCCESS";
export const CHAT_GET_LLM_PROMPTS_SUCCESS = "CHAT_GET_LLM_PROMPTS_SUCCESS";
export const CHAT_GET_MODELS_VOICES_SUCCESS = " CHAT_GET_MODELS_VOICES_SUCCESS";
export const CHAT_GET_CONFIG_SUCCESS = "CHAT_GET_CONFIG_SUCCESS";
export const WORKSPACE_LIST_SUCCESS_FOR_CHAT =
  "WORKSPACE_LIST_SUCCESS_FOR_CHAT";
export const CHAT_GET_ATTACHMENT_SUCCESS = "CHAT_GET_ATTACHMENT_SUCCESS ";
// export const CHAT_GET_PERSONA_SUCCESS ='CHAT_GET_PERSONA_SUCCESS';
// export const CHAT_GET_INSTRUCTIONS_SUCCESS ='CHAT_GET_INSTRUCTIONS_SUCCESS';

const SHOW_LOADER = "SHOW_LOADER";
const HIDE_LOADER = "HIDE_LOADER";

//attachment consts
export const WORKSPACE_ATTACHMENT_VALIDATION_ERROR =
  "WORKSPACE_ATTACHMENT_VALIDATION_ERROR";
export const WORKSPACE_ATTACHMENT_SUCCESS = "WORKSPACE_ATTACHMENT_SUCCESS";

const showCommonLoader = (label = "") => ({
  type: SHOW_LOADER,
  common_loder_label: label,
});
const hideCommonLoader = () => ({
  type: HIDE_LOADER,
});

const workspaceRequest = () => ({
  type: WORKSPACE_REQUEST,
});

const getDesc = (val) => {
  let desc = trimAndLimit(val, 65355);
  return desc !== "null" && desc !== null ? desc : "";
};

export const workspaceServerListSuccess = () => ({
  type: WORKSPACE_SERVER_SUCCESS,
});

const workspaceListSuccess = (workspaceList) => ({
  type: WORKSPACE_SUCCESS,
  workspaceList: workspaceList,
});

const getUSerSuccess = (getUser) => ({
  type: USER_ACCESS,
  getUser: getUser,
});

export const workspaceFailure = (notification) => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: notification,
  snackbar_notification_type: "general_error",
});

const validationError = (notification) => ({
  type: WORKSPACE_VALIDATION_ERROR,
  validation_error: notification,
});
const tokenError = (notification) => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: notification,
  snackbar_notification_type: "token_expire",
});

const workspaceConfigurationSuccess = (message, action, dispatch) => {
  dispatch(WorkspaceConfigurationSuccessNotification(message));
  dispatch(redirectToWorkspaceConfigurationList());
};

export const redirectToWorkspaceConfigurationList = () => ({
  type: REDIRECT_TO_WORKSPACE_CONFIGURATION_LIST,
});

const workspaceAddUpadteSuccess = (message, action, dispatch, user_id) => {
  dispatch(workspaceSuccessNotification(message));
  dispatch(redirectToWorkspaceList());

  // Refresh workspaces for the specific user
  // if (user_id) {
  //   dispatch(workspaceListFetch(user_id));
  // }
};

const chatAttachmentSuccess = (message, dispatch) => {
  dispatch(chatAttachmentSuccessNotification(message));
};

export const redirectToWorkspaceList = () => ({
  type: REDIRECT_TO_WORKSPACE_LIST,
});

const getWorkspaceSuccess = (response, action) => ({
  type: WORKSPACE_GET_SUCCESS,
  record: response,
  actionType: action,
});

const chatAttachmentSuccessNotification = (message) => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: message,
  snackbar_notification_type: "success",
});

const fileAttachmentSuccessNotification = (message) => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: message,
  snackbar_notification_type: "success",
});

const workspaceSuccessNotification = (message) => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: message,
  snackbar_notification_type: "success",
});
const WorkspaceConfigurationSuccessNotification = (message) => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: message,
  snackbar_notification_type: "success",
});

export const hideWorkspaceValidationError = (feild_key) => ({
  type: HIDE_WORKSPACE_FEILD_VALIDATION_ERROR,
  feild_key: feild_key,
});

const workspaceListSuccessForChat = (workspaceListForChat) => ({
  type: WORKSPACE_LIST_SUCCESS_FOR_CHAT,
  workspaceListForChat: workspaceListForChat,
});

export const workspaceListFetchForChat = (user_id, object_viewed_id = "") => {
  var token = localStorage.getItem("token");
  return (dispatch) => {
    dispatch(workspaceRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + "workspace", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      params: {
        user_id: user_id,
        object_viewed_id: object_viewed_id,
      },
    }).then(
      (response) => {
        dispatch(hideCommonLoader());
        dispatch(workspaceListSuccessForChat(response.data));
      },
      (error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      },
    );
  };
};

export const workspaceListFetch = (user_id, object_viewed_id = "") => {
  var token = localStorage.getItem("token");
  return (dispatch) => {
    dispatch(workspaceRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + "workspace", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      params: {
        user_id: user_id,
      },
    }).then(
      (response) => {
        dispatch(hideCommonLoader());
        dispatch(workspaceListSuccess(response.data));
      },
      (error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      },
    );
  };
};

export const userFetch = (object_viewed_id = "") => {
  var token = localStorage.getItem("token");
  return (dispatch) => {
    dispatch(workspaceRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + "user/getAll", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      // params: { object_viewed_id: object_viewed_id }
    }).then(
      (response) => {
        dispatch(hideCommonLoader());
        dispatch(getUSerSuccess(response.data));
      },
      (error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      },
    );
  };
};

export const addWorkspace = (data, user_id) => {
  var token = localStorage.getItem("token");
  return (dispatch) => {
    dispatch(workspaceRequest());
    dispatch(showCommonLoader());

    return axios(API_URL + "workspace/create", {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      data: data,
    })
      .then((response) => {
        dispatch(hideCommonLoader());

        workspaceAddUpadteSuccess(
          "Workspace Added Successfully",
          "create",
          dispatch,
          user_id, // Pass user_id here
        );
      })
      .catch((error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      });
  };
};

export const updateWorkspace = (data, old_name, new_name) => {
  const token = localStorage.getItem("token");
  return async (dispatch) => {
    dispatch(workspaceRequest());
    dispatch(showCommonLoader());

    try {
      await axios(API_URL + "workspace/update/" + data.get("id"), {
        method: "POST",
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + token,
        },
        data: data,
      });

      workspaceAddUpadteSuccess(
        "Workspace Updated Successfully",
        "update",
        dispatch,
      );

      // axios(GYPSYBALL_PYTHON_API_URL + 'update/workspace', {
      //   method: 'POST',
      //   headers: {
      //     'Content-Type': 'application/json',
      //     Accept: 'application/json',
      //   },
      //   data: {
      //     old_name,
      //     new_name,
      //   },
      // });
    } catch (error) {
      handleErrorResponse(error, dispatch);
    } finally {
      dispatch(hideCommonLoader());
    }
  };
};

export const getWorkspaceById = (id, action) => {
  var token = localStorage.getItem("token");
  return (dispatch) => {
    dispatch(workspaceRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + "workspace/getById/" + id, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
    }).then(
      (response) => {
        dispatch(hideCommonLoader());
        dispatch(getWorkspaceSuccess(response.data, action));
      },
      (error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      },
    );
  };
};

export const deleteWorkspace = (workspaceId, listParams, workspaceName) => {
  // listParams should contain: { user_id, object_viewed_id, scope? }
  const { user_id, object_viewed_id } = listParams;

  var token = localStorage.getItem("token");

  return (dispatch) => {
    dispatch(workspaceRequest());
    dispatch(showCommonLoader());

    return axios(API_URL + "workspace/delete/" + workspaceId, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      data: {
        object_viewed_id,
      },
    })
      .then(() => {
        dispatch(hideCommonLoader());
        dispatch(
          workspaceSuccessNotification("Workspace deleted successfully"),
        );

        // Optional: Delete workspace from Gypsyball services
        axios(GYPSYBALL_PYTHON_API_URL + "delete/workspace", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${GYPSYBALL_PYTHON_API_TOKEN}`,
          },
          data: { workspace: workspaceName },
        });

        axios(GYPSYBALL_PYTHON_API_URL + "delete/chathistory", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${GYPSYBALL_PYTHON_API_TOKEN}`,
          },
          data: {
            user_id,
            workspace: workspaceName,
          },
        });

        // Refresh workspace list for the current user
        if (user_id) {
          dispatch(workspaceListFetch(user_id));
        }
      })
      .catch((error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      });
  };
};

/*
 * Workspace dropdown list fetch methods
 */
const workspaceDropdownListSuccess = (workspaceDropdownList) => ({
  type: WORKSPACE_DROPDOWN_LIST_SUCCESS,
  workspaceDropdownList: workspaceDropdownList,
});

export const workspaceDropdownListFetch = (user_id, object_viewed_id = "") => {
  var token = localStorage.getItem("token");
  return (dispatch) => {
    dispatch(workspaceRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + "workspace/getAllForDropdown", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      params: {
        object_viewed_id: object_viewed_id,
        user_id: user_id,
      },
    }).then(
      (response) => {
        dispatch(workspaceDropdownListSuccess(response.data));
        dispatch(hideCommonLoader());
      },
      (error) => {
        handleErrorResponse(error, dispatch);
        dispatch(hideCommonLoader());
      },
    );
  };
};

/*
 * attachment  methods
 */
export const uploadWorkspaceAttachments = (data, object_viewed_id) => {
  var token = localStorage.getItem("token");
  let workspace_id = data.get("id");

  return (dispatch) => {
    dispatch(workspaceRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + "workspace/uploadAttachments/" + workspace_id, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      data: data,
    }).then(
      (response) => {
        dispatch(hideCommonLoader());
        dispatch(
          workspaceSuccessNotification("Attachments Uploaded Successfully"),
        );
        //dispatch(redirectToWorkspacesList())
      },
      (error) => {
        dispatch(hideCommonLoader());
        handleAttachmentErrorResponse(error, dispatch);
      },
    );
  };
};

export const getAttachmentsByWorkspaceId = (id) => {
  var token = localStorage.getItem("token");
  return (dispatch) => {
    dispatch(showCommonLoader());
    dispatch(workspaceRequest());
    return axios(API_URL + "workspace/getAttachments/" + id, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
    }).then(
      (response) => {
        dispatch(getAttachmentSuccess(response.data));
        dispatch(hideCommonLoader());
      },
      (error) => {
        handleErrorResponse(error, dispatch);
        dispatch(hideCommonLoader());
      },
    );
  };
};

export const deleteWorkspaceAttachment = (id, object_viewed_id) => {
  var token = localStorage.getItem("token");
  return (dispatch) => {
    dispatch(workspaceRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + "workspace/deleteAttachment/" + id, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      data: {
        object_viewed_id,
      },
    }).then(
      (response) => {
        dispatch(hideCommonLoader());
        dispatch(
          workspaceSuccessNotification("Attachment deleted successfully"),
        );
      },
      (error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      },
    );
  };
};

const getAttachmentSuccess = (response) => ({
  type: WORKSPACE_ATTACHMENT_SUCCESS,
  workspaceAttachmentList: response,
});

const attachmentValidationError = (notification) => ({
  type: WORKSPACE_ATTACHMENT_VALIDATION_ERROR,
  attachment_validation_error: notification,
});

const handleAttachmentErrorResponse = (error, dispatch) => {
  try {
    if (error.response.status === 422 && error.response.data.error) {
      dispatch(attachmentValidationError(error.response.data.error));
    } else if (error.response.status === 401 && error.response.data.error) {
      dispatch(tokenError(error.response.data.error.toString()));
    } else {
      let err = "";
      if (error.response.data.error) {
        err = error.response.data.error.toString();
      } else {
        err = error.response.status + ` ` + error.response.statusText;
      }
      dispatch(workspaceFailure(err));
    }
  } catch (e) {
    dispatch(workspaceFailure("Unable to perform action.Something went wrong"));
  }
};

export const updateWorkspaceContext = (data) => {
  var token = localStorage.getItem("token");
  return (dispatch) => {
    dispatch(workspaceRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + "workspace/updateContext", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      data: data,
    }).then(
      (response) => {
        dispatch(hideCommonLoader());
        dispatch(
          workspaceSuccessNotification(
            "Workspace Context Updated Successfully",
          ),
        );
      },
      (error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      },
    );
  };
};

// handling error reponse
const handleErrorResponse = (error, dispatch) => {
  try {
    if (error.response.status === 422 && error.response.data.error) {
      dispatch(validationError(error.response.data.error));
    } else if (error.response.status === 401 && error.response.data.error) {
      dispatch(tokenError(error.response.data.error.toString()));
    } else {
      let err = "";
      if (error.response.data.error) {
        err = error.response.data.error.toString();
      } else {
        err = error.response.status + ` ` + error.response.statusText;
      }
      dispatch(workspaceFailure(err));
    }
  } catch (e) {
    dispatch(workspaceFailure("Unable to perform action.Something went wrong"));
  }
};

export const saveAiSessionResponse = (data) => {
  var token = localStorage.getItem("token");
  return (dispatch) => {
    dispatch(workspaceRequest());
    // dispatch(showCommonLoader());
    return axios(API_URL + "workspace/session", {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      data: data,
    }).then(
      (response) => {
        dispatch(hideCommonLoader());
        workspaceAddUpadteSuccess("", "", dispatch);
      },
      (error) => {
        // dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
        // dispatch(workspaceFailure("The name has already been taken"))
      },
    );
  };
};

// chat with workspace
export const chatWithContext = (
  context_file,
  user_question,
  messages,
  setMessages,
) => {
  return (dispatch) => {
    dispatch(showCommonLoader());
    return axios("https://gypsyball-python.azurewebsites.net/chat", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      data: JSON.stringify({
        context_blob_name: context_file,
        user_question: user_question,
      }),
    }).then(
      (response) => {
        dispatch(hideCommonLoader());
        setMessages((prevState) => ({
          ...prevState,
          messages: [
            ...prevState.messages,
            {
              id: uuidv4(),
              sender: {
                authUser: false,
              },
              content: response.data.chatbot_response.replace(/\n/g, "<br>"),
            },
          ],
        }));
      },
      (error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      },
    );
  };
};

// chat with workspace
export const chatWithContextV2 = (
  session_id,
  workspace,
  user_question,
  messages,
  setMessages,
) => {
  return (dispatch) => {
    dispatch(showCommonLoader());
    return axios(GYPSYBALL_PYTHON_API_URL + "anthropic/test/msg", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${GYPSYBALL_PYTHON_API_TOKEN}`,
      },
      data: JSON.stringify({
        session_id: session_id,
        question: user_question,
        workspace: workspace,
      }),
    }).then(
      (response) => {
        dispatch(hideCommonLoader());
        setMessages((prevState) => ({
          ...prevState,
          messages: [
            ...prevState.messages,
            {
              id: uuidv4(),
              sender: {
                authUser: false,
              },
              content: response.data.answer.replace(/\n/g, "<br>"),
            },
          ],
        }));
      },
      (error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      },
    );
  };
};

export const chatWithContextV3 = (
  session_id,
  workspace,
  llmModelValue,
  user_question,
  messages,
  allowedExcelRowsValue,
  setllmPromptsValue,
  generalRules,
  userId,
  userEmail,
  persona,
  rules,
  instructions,
) => {
  return (dispatch) => {
    dispatch(showCommonLoader());

    const payload = {
      session_id: session_id || "",
      question: user_question || "",
      workspace: workspace || "",
      llm: llmModelValue || "",
      k: isNaN(parseInt(allowedExcelRowsValue)) ? 0 : allowedExcelRowsValue,
      system_msg: generalRules || "",
      length_of_answer: setllmPromptsValue || "",
      user_id: userId || "",
      user_email: userEmail || "",
      persona: persona || "",
      rules: rules || "",
      instructions: instructions || "",
    };

    return axios(GYPSYBALL_PYTHON_API_URL + "llm/msg", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${GYPSYBALL_PYTHON_API_TOKEN}`,
      },
      data: JSON.stringify(payload),
    }).then(
      (response) => {
        dispatch(hideCommonLoader());

        return response;
      },
      (error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      },
    );
  };
};

export const chatWithAudio = (
  workspace,
  soundValue,
  voiceModelValue,
  llmModelValue,
  audioBase64,
  allowedExcelRowsValue,
  session_id,
  userId,
  userEmail,
) => {
  return (dispatch) => {
    dispatch(showCommonLoader());

    const payload = {
      workspace: workspace || "",
      ID: soundValue || "",
      tts_model: voiceModelValue || "",
      llm: llmModelValue || "",
      base64_data: audioBase64 || "",
      // base64_data:'https://www.soundhelix.com/examples/mp3/SoundHel-Song-1.mp3',
      k: isNaN(parseInt(allowedExcelRowsValue)) ? 0 : allowedExcelRowsValue,
      session_id: session_id || "",
      user_id: userId || "",
      user_email: userEmail || "",
    };

    // return axios('https://vapi-middleware.azurewebsites.net/transcribe', {
    return axios(GYPSYBALL_PYTHON_API_URL + "transcribe", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${GYPSYBALL_PYTHON_API_TOKEN}`,
      },
      data: JSON.stringify(payload),
    }).then(
      (response) => {
        dispatch(hideCommonLoader());
        return response;
      },
      (error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      },
    );
  };
};

export const downloadChatSummary = (session_id) => {
  return (dispatch) => {
    dispatch(showCommonLoader());

    const payload = {
      session_id: session_id || "",
    };

    return axios(GYPSYBALL_PYTHON_API_URL + "export/conversation", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${GYPSYBALL_PYTHON_API_TOKEN}`,
      },
      data: payload,
    }).then(
      (response) => {
        dispatch(hideCommonLoader());

        return response;
      },
      (error) => {
        dispatch(hideCommonLoader());
        dispatch(
          workspaceSuccessNotification("Chat History Downloaded Successfully"),
        );
        handleErrorResponse(error, dispatch);
      },
    );
  };
};

export const uploadChatAttachment = (filesData, sessionId, user_id) => {
  return (dispatch) => {
    dispatch(workspaceRequest());
    dispatch(showCommonLoader());

    const token = localStorage.getItem("token");

    return axios
      .post(
        `${GYPSYBALL_PYTHON_API_URL}uploadfile/session?user_id=${user_id}&session_id=${sessionId}`,
        filesData,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${GYPSYBALL_PYTHON_API_TOKEN}`,
          },
        },
      )
      .then((response) => {
        dispatch(hideCommonLoader());
        chatAttachmentSuccess("Documents Uploaded Successfully", dispatch);
        dispatch(getChatAttachmentSuccess(response.data));
        return response.data;
      })
      .catch((error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
        throw error;
      });
  };
};

export const uploadAudioAttachment = (filesData, sessionId, user_id) => {
  return (dispatch) => {
    dispatch(workspaceRequest());
    dispatch(showCommonLoader());

    const token = localStorage.getItem("token");

    return axios(GYPSYBALL_PYTHON_API_URL + "transcribe-audio", {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${GYPSYBALL_PYTHON_API_TOKEN}`,
      },
      data: filesData,
      method: "POST",
    })
      .then((response) => {
        dispatch(hideCommonLoader());
        chatAttachmentSuccess("Audio Uploaded Successfully", dispatch);
        dispatch(getChatAttachmentSuccess(response.data));
        return response.data;
      })
      .catch((error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
        throw error;
      });
  };
};

export const sendTranscribeResponse = (data) => {
  return (dispatch) => {
    dispatch(workspaceRequest());
    dispatch(showCommonLoader());

    const token = localStorage.getItem("token");

    return axios(GYPSYBALL_PYTHON_API_URL + "uploadtranscript", {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${GYPSYBALL_PYTHON_API_TOKEN}`,
      },
      data: data,
      method: "POST",
    })
      .then((response) => {
        dispatch(hideCommonLoader());
        chatAttachmentSuccess("Text ingested successfully", dispatch);
        dispatch(getChatAttachmentSuccess(response.data));
        return;
      })
      .catch((error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
        throw error;
      });
  };
};

const getLLMModelsSuccess = (llmList) => ({
  type: CHAT_GET_LLM_MODEL_SUCCESS,
  llmList: llmList,
});

const getLLMPromptsSuccess = (llmPrompts) => ({
  type: CHAT_GET_LLM_PROMPTS_SUCCESS,
  llmPrompts: llmPrompts,
});

const getModalVoicesSuccess = (modelVoices) => ({
  type: CHAT_GET_MODELS_VOICES_SUCCESS,
  modelVoices: modelVoices,
});

const getChatAttachmentSuccess = (chatAttachment) => ({
  type: CHAT_GET_ATTACHMENT_SUCCESS,
  chatAttachment: chatAttachment,
});
export const getLLMModels = () => {
  return (dispatch) => {
    dispatch(showCommonLoader());
    return axios(GYPSYBALL_PYTHON_API_URL + "llm/list", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${GYPSYBALL_PYTHON_API_TOKEN}`,
      },
    }).then(
      (response) => {
        dispatch(hideCommonLoader());
        dispatch(getLLMModelsSuccess(response.data.llm));
      },
      (error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      },
    );
  };
};

export const getLLMPrompts = () => {
  return (dispatch) => {
    dispatch(showCommonLoader());
    return axios(GYPSYBALL_PYTHON_API_URL + "llm/prompts", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${GYPSYBALL_PYTHON_API_TOKEN}`,
      },
    }).then(
      (response) => {
        dispatch(hideCommonLoader());

        dispatch(getLLMPromptsSuccess(response.data.prompts));
      },
      (error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      },
    );
  };
};

// get voices
export const getModelVoices = () => {
  return (dispatch) => {
    dispatch(showCommonLoader());
    return axios(GYPSYBALL_PYTHON_API_URL + "get-voices", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${GYPSYBALL_PYTHON_API_TOKEN}`,
      },
    }).then(
      (response) => {
        dispatch(hideCommonLoader());
        dispatch(getModalVoicesSuccess(response.data));
      },
      (error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      },
    );
  };
};

export const updateWorkspaceConfiguration = (data) => {
  var token = localStorage.getItem("token");
  return (dispatch) => {
    dispatch(workspaceRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + "workspace/updateWorkspaceConfiguration", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      data: data,
    }).then(
      (response) => {
        dispatch(hideCommonLoader());
        workspaceAddUpadteSuccess(
          "Workspace Configuration Done Successfully",
          "create",
          dispatch,
        );
      },
      (error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      },
    );
  };
};

const getVerifyConfigSuccess = (configVerify) => ({
  type: CHAT_GET_CONFIG_SUCCESS,
  configVerify: configVerify,
});

export const checkApiResponse = (formData, api_response, onHide) => {
  return async (dispatch) => {
    const errors = [];
    const python_api_response = api_response;
    const api_response_text = JSON.stringify(python_api_response);
    let response_flag = api_response_text.includes("false");
    let object_flag = false;

    Object.keys(python_api_response).forEach((key) => {
      if (python_api_response[key]?.status === false) {
        errors.push(python_api_response[key]?.reason);
        dispatch(workspaceFailure(python_api_response[key]?.reason));
        object_flag = true;
      }
    });

    if (response_flag && !object_flag) {
      if (python_api_response.status === false)
        dispatch(workspaceFailure(python_api_response.msg));
      else
        dispatch(workspaceFailure("Unable to process request due to an error"));
    } else if (!(errors.length > 0)) {
      const updatedFormData = {
        ...formData,
        last_api_response: python_api_response,
      };

      await dispatch(updateWorkspaceConfiguration(updatedFormData));

      // ✅ Trigger AI API call
      await dispatch(aiWorkspaceConfiguration(formData));

      onHide();
    }
  };
};

export const verifyWorkspaceConfig = (formData, onHide) => {
  return (dispatch) => {
    dispatch(showCommonLoader());

    return axios(GYPSYBALL_PYTHON_API_URL + "verify/verifyConfig2", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${GYPSYBALL_PYTHON_API_TOKEN}`,
      },
      data: formData.verifyData,
    }).then(
      (response) => {
        dispatch(hideCommonLoader());
        dispatch(checkApiResponse(formData, response.data, onHide));
        dispatch(getVerifyConfigSuccess(response.data.status));
      },
      (error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      },
    );
  };
};

export const aiWorkspaceConfiguration = (formData) => {
  return async (dispatch) => {
    let persona = "";
    let rules = "";
    let instructions = "";

    try {
      const verifyData = JSON.parse(formData.verifyData);
      persona = verifyData.persona || "";
      rules = verifyData.rules || "";
      instructions = verifyData.instruction || "";
    } catch (e) {
      // console.error("Error parsing verifyData:", e);
    }

    const aiPayload = {
      workspace: formData.workspaceLabel,
      llm: formData.llm_model,
      k_value: formData.allowed_excel_rows,
      persona,
      rules,
      instructions,
    };

    dispatch(showCommonLoader());

    try {
      const response = await axios({
        method: "POST",
        url: GYPSYBALL_PYTHON_API_URL + "workspace-config",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${GYPSYBALL_PYTHON_API_TOKEN}`,
        },
        data: aiPayload,
      });

      // console.log(`API Status Code: ${response.status}`);
      // console.log('API Response Data:', response.data);

      if (response.status === 200) {
        // console.log('✅ Successful response (200 OK)');
      } else if (response.status === 500) {
        // console.log('❌ Server Error (500)');
        dispatch(updateAiWorkspaceConfiguration(formData));
      } else {
        // console.log(`⚠️ Received unexpected status: ${response.status}`);
      }

      dispatch(hideCommonLoader()); // ✅ Hide loader after response

      return response.data;
    } catch (error) {
      // console.error('Axios Error:', error);

      if (error.response) {
        const status = error.response.status;
        // console.error(`Error Status: ${status}`);

        if (status === 500) {
          dispatch(updateAiWorkspaceConfiguration(formData)); // ✅ Use original formData here
        }
      }

      dispatch(hideCommonLoader()); // ✅ Always hide loader on error
    }
  };
};

export const updateAiWorkspaceConfiguration = (formData) => {
  return async (dispatch) => {
    const token = localStorage.getItem("token");

    const aiPayload = {
      workspace: formData.workspaceLabel,
      llm: formData.llm_model,
      k_value: formData.allowed_excel_rows,
      persona: formData.persona || "",
      rules: formData.rules || "",
      instructions: formData.instructions || "",
    };

    let persona = "";
    let rules = "";
    let instructions = "";

    try {
      const verifyData = JSON.parse(formData.verifyData);
      persona = verifyData.persona || "";
      rules = verifyData.rules || "";
      instructions = verifyData.instruction || "";
    } catch (e) {
      // fallback if verifyData is not a valid JSON string
      persona = formData.persona || "";
      rules = formData.rules || "";
      instructions = formData.instructions || "";
    }

    // Do not discard llm and k (llm_model and allowed_excel_rows)
    aiPayload.persona = persona;
    aiPayload.rules = rules;
    aiPayload.instructions = instructions;
    aiPayload.llm = formData.llm_model || aiPayload.llm;
    aiPayload.k_value = formData.allowed_excel_rows || aiPayload.k_value;
    try {
      dispatch(showCommonLoader());

      const response = await axios(
        GYPSYBALL_PYTHON_API_URL +
          "workspace-config/" +
          formData.workspaceLabel,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${GYPSYBALL_PYTHON_API_TOKEN}`,
          },
          data: aiPayload,
        },
      );

      dispatch(hideCommonLoader());
      // console.log("AI API success:", response.data);
      // Optionally: dispatch a success action here
    } catch (error) {
      dispatch(hideCommonLoader());
      // console.error("AI API error:", error);
      // Optionally: dispatch a failure action here
    }
  };
};

export const sessionStop = (data) => async (dispatch) => {
  var token = localStorage.getItem("token");

  dispatch(workspaceRequest());
  dispatch(showCommonLoader());

  try {
    const response = await axios.post(
      GYPSYBALL_PYTHON_API_URL + "session/stop",
      data,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${GYPSYBALL_PYTHON_API_TOKEN}`,
        },
      },
    );

    // Process response if needed

    // Hide loader only after successful response
    dispatch(hideCommonLoader());

    // Uncomment this line if workspace update success handling is needed
    // workspaceAddUpadteSuccess('Workspace Configuration Done Successfully', 'create', dispatch);
  } catch (error) {
    // console.error('Error:', error);
    dispatch(hideCommonLoader());
    handleErrorResponse(error, dispatch);
  }
};

export const workspaceExposure = (data) => {
  const token = localStorage.getItem("token");
  const workspace_id = data.id;
  const workspace = data.name;
  const toggle = data.isExposed;

  return async (dispatch) => {
    dispatch(workspaceRequest());
    dispatch(showCommonLoader());

    try {
      // First API call to Gypsyball Python API
      const gypsyballResponse = await axios(
        GYPSYBALL_PYTHON_API_URL + "toggle",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${GYPSYBALL_PYTHON_API_TOKEN}`,
          },
          data: {
            workspace,
            toggle,
          },
        },
      );

      const response_url = gypsyballResponse.data?.response_url;

      if (!response_url) {
        throw new Error("Gypsyball API did not return a response_url");
      }

      dispatch(workspaceRequest());
      dispatch(showCommonLoader());
      // Second API call to the local API
      const workspaceApiResponse = await axios(
        API_URL + "workspace/workspaceExposure/" + workspace_id,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
          data: {
            workspace,
            toggle,
            response_url,
          },
        },
      );

      // Return the final response data
      return {
        gypsyballData: gypsyballResponse.data,
        workspaceApiData: workspaceApiResponse.data,
      };
    } catch (error) {
      handleErrorResponse(error, dispatch);
      throw error; // Re-throw the error for handling in the calling component
    } finally {
      dispatch(hideCommonLoader());
      // workspaceAddUpadteSuccess('Workspace Exposure Done Successfully','create',dispatch);
    }
  };
};
